import { ColumnDefinition } from "./DexieServises";

export function generateColumnsAndDataFromResponse(
    raw: any,
    idStart = 1
): { columns: ColumnDefinition[]; records: Record<string, any>[] } {
    if (!raw || (typeof raw !== 'object' && !Array.isArray(raw))) {
        return { columns: [], records: [] };
    }

    const rows = Array.isArray(raw) ? raw : [raw];
    const columns: ColumnDefinition[] = [
        { name: 'id', type: 'number', isPrimaryKey: true }
    ];
    const columnSet = new Set<string>(['id']);
    const recordsArray: Record<string, any>[] = [];

    for (const row of rows) {
        const sanitizedRecord: Record<string, any> = { id: idStart++ };

        for (const key of Object.keys(row)) {
            if (key === 'id') continue;

            const value = row[key];
            const type = detectType(value);

            sanitizedRecord[key] =
                type === 'date' ? new Date(value) : value ?? null;

            if (!columnSet.has(key)) {
                columns.push({ name: key, type });
                columnSet.add(key);
            }
        }

        // Optional: Add isActive if desired
        if (!columnSet.has('isActive')) {
            columns.push({ name: 'isActive', type: 'boolean' });
            columnSet.add('isActive');
        }

        sanitizedRecord.isActive = true;

        recordsArray.push(sanitizedRecord);
    }

    return { columns, records: recordsArray };
}


function detectType(value: any): ColumnDefinition['type'] {
    if (typeof value === 'boolean') return 'boolean';
    if (typeof value === 'number') return 'number';

    if (typeof value === 'string') {
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) return 'date';
        return 'string';
    }

    if (value instanceof Date) return 'date';

    return 'string';
}
